import Vue from 'vue';
import VueSession from 'vue-session';

const optionsSession = {
  persist: false,
};

Vue.use(VueSession, optionsSession);

Vue.filter('dateTimeFormatter', (unix) => {
  const t = new Date(unix);
  const zeroPad = (value: any, size: any): string => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value);
  return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)} ${zeroPad(t.getHours(), 2)}:${zeroPad(t.getMinutes(), 2)}:${zeroPad(t.getSeconds(), 2)}`;
});

Vue.filter('commaFormatter', (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

Vue.filter('upperCamel', (text) => text
  .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return '';
    return index === 0 ? match.toUpperCase() : match.toLowerCase();
  }));

export default {
  getUserPersistent() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-authenticate')) {
        return {
          user: {
            _id: null,
            username: null,
            type: null,
            nickname: null,
            source: null,
            level: null,
            wallet: null,
            commission: null,
          },
          token: '',
          refreshToken: '',
        };
      }
      return JSON.parse(Vue.prototype.$session.get('ambgames-user-authenticate'));
    } else {
      return {
        user: {
          _id: null,
          username: null,
          type: null,
          nickname: null,
          source: null,
          level: null,
          wallet: null,
          commission: null,
        },
        token: '',
        refreshToken: '',
      };
    }
  },
  clearUserPersistent() {
    Vue.prototype.$session.destroy('ambgames-user-authenticate');
    Vue.prototype.$session.destroy('ambgames-user-refresh-token');
    Vue.prototype.$session.destroy('ambgames-user-access-token');
    delete Vue.axios.defaults.headers.common.Authorization;
  },
  getUserBalance() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-balance')) {
        return 0;
      }
      return Vue.prototype.$session.get('ambgames-user-balance');
    }
  },
  currencyFormatter(balance: number) {
    const x = balance;
    if (x === 0) {
      return '0.00';
    } else if (!x) {
      return x;
    }
    return x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  },
  colorCurrency(value) {
    if (value < 0) return 'red-text';
    return '';
  },
  colorCurrencyLog(value) {
    if (value > 0) return 'green-text';
    if (value < 0) return 'red-text';
    return '';
  },
  colorWinloss(value) {
    if (value > 0) return 'green-text';
    if (value < 0) return 'red-text';
    return 'blue-text';
  },
  winloseStatus(value) {
    if (value > 0) return 'Win';
    if (value < 0) return 'Loss';
    return 'Tie';
  },
};
